import { useIntl } from 'react-intl'
import { useConfiguration } from '@/scopes/common/infrastructure/config/ConfigProvider'
import styles from './LegalMenuBar.module.css'

export default function LegalMenuBar() {
  const intl = useIntl()
  const links = useConfiguration('links')

  return (
    <section className={styles.links}>
      <a className={styles.link} href={links.about}>{intl.formatMessage({ id: 'footer_about' })}</a>
      <a className={styles.link} href={links.jobs}>{intl.formatMessage({ id: 'footer_jobs' })}</a>
      <a className={styles.link} href={links.conditions}>{intl.formatMessage({ id: 'footer_conditions' })}</a>
      <a className={styles.link} href={links.cookiesSettings}>{intl.formatMessage({ id: 'footer_cookies' })}</a>
      <a className={styles.link} href={links.accessibility}>{intl.formatMessage({ id: 'footer_accessibility' })}</a>
      {links.disclaimer
      && <a className={styles.link} href={links.disclaimer}>{intl.formatMessage({ id: 'footer_disclaimer' })}</a>}
      <a className={styles.link} href={links.sitemap}>{intl.formatMessage({ id: 'footer_sitemap' })}</a>
    </section>
  )
}
